

// This file is auto-generated on 'generateCondoEnumTypings.ts'. Do not edit it manually.
export interface CondoDictionaryObject<T> {
	name: string;
	identifier: T;
}

export enum CondoTypeEnum {
HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export interface CondoTypeObject extends CondoDictionaryObject<CondoTypeEnum> { }

export const condoTypes: CondoDictionaryObject<CondoTypeEnum>[] = [
	{ name: 'Casas', identifier: CondoTypeEnum.HORIZONTAL },
  { name: 'Apartamentos', identifier: CondoTypeEnum.VERTICAL },
];

export const condoTypesTranslations: Record<CondoTypeEnum, string> = {
	[CondoTypeEnum.HORIZONTAL]: 'Casas',
  [CondoTypeEnum.VERTICAL]: 'Apartamentos',
}

export enum CondoTypeSlug {
	HORIZONTAL = 'casas',
  VERTICAL = 'apartamentos',
}

export const condoTypesSlugByValue: Record<CondoTypeEnum, CondoTypeSlug> = {
	[CondoTypeEnum.HORIZONTAL]: CondoTypeSlug.HORIZONTAL,
  [CondoTypeEnum.VERTICAL]: CondoTypeSlug.VERTICAL,
}

export enum CondoStatusEnum {
	FINISHED = 'finished',
  OFF_PLAN = 'off_plan',
  UNDER_CONSTRUCTION = 'under_construction',
}

export const condoStatus: CondoDictionaryObject<CondoStatusEnum>[] = [
	{ name: 'Pronto', identifier: CondoStatusEnum.FINISHED },
  { name: 'Na planta', identifier: CondoStatusEnum.OFF_PLAN },
  { name: 'Em construção', identifier: CondoStatusEnum.UNDER_CONSTRUCTION },
];

export const condoStatusTranslations: Record<CondoStatusEnum, string> = {
	[CondoStatusEnum.FINISHED]: 'Pronto',
  [CondoStatusEnum.OFF_PLAN]: 'Na planta',
  [CondoStatusEnum.UNDER_CONSTRUCTION]: 'Em construção',
}

export enum CondoStatusSlug {
	FINISHED = 'pronto',
  OFF_PLAN = 'na-planta',
  UNDER_CONSTRUCTION = 'em-construcao',
}

export const condoStatusSlugByValue: Record<CondoStatusEnum, CondoStatusSlug> = {
	[CondoStatusEnum.FINISHED]: CondoStatusSlug.FINISHED,
  [CondoStatusEnum.OFF_PLAN]: CondoStatusSlug.OFF_PLAN,
  [CondoStatusEnum.UNDER_CONSTRUCTION]: CondoStatusSlug.UNDER_CONSTRUCTION,
}

export enum CondoFeatureCategory {
	FACILITIES = 'facilities',
  DIFFERENTIALS = 'differentials',
  EXTERNAL_AREA = 'external_area',
  ROOMS = 'rooms',
}

export const condoFeatureCategoriesTranslations: Record<CondoFeatureCategory, string> = {
	[CondoFeatureCategory.FACILITIES]: 'Facilidades',
  [CondoFeatureCategory.DIFFERENTIALS]: 'Diferenciais',
  [CondoFeatureCategory.EXTERNAL_AREA]: 'Área externa',
  [CondoFeatureCategory.ROOMS]: 'Cômodos',
}

export interface CondoFeatureCategoryObject extends CondoDictionaryObject<CondoFeatureCategory> {}

export const condoFeatureCategories: CondoFeatureCategoryObject[] = [
	{ name: 'Facilidades', identifier: CondoFeatureCategory.FACILITIES },
  { name: 'Diferenciais', identifier: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Área externa', identifier: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Cômodos', identifier: CondoFeatureCategory.ROOMS },
];

export enum CondoFeatureEnum {
	ACCESSIBILITY = 'accessibility',
  AIR_CONDITIONING = 'air_conditioning',
  ALL_TIME_FRONTDESK = 'all_time_frontdesk',
  AUTHOR_ARCHITECTURE = 'author_architecture',
  BANQUET_HALL = 'banquet_hall',
  BARBECUE_GRILL = 'barbecue_grill',
  BATHTUB = 'bathtub',
  BIKE_PARKING = 'bike_parking',
  CLOSET = 'closet',
  COWORKING = 'coworking',
  DAYTIME_FRONTDESK = 'daytime_frontdesk',
  DEED_PARKING_SPOT = 'deed_parking_spot',
  DELIVERY_ELEVATOR = 'delivery_elevator',
  ELECTRIC_CAR_PARKING_SPOT = 'electric_car_parking_spot',
  ELECTRIC_HEATING = 'electric_heating',
  ELECTRONIC_FRONTDESK = 'electronic_frontdesk',
  FIREPLACE = 'fireplace',
  FIXED_PARKING_SPOT = 'fixed_parking_spot',
  FOR_RENOVATION = 'for_renovation',
  FREE_PARKING_SPOT = 'free_parking_spot',
  FURNISHED = 'furnished',
  GAME_ROOM = 'game_room',
  GAS_HEATING = 'gas_heating',
  GENERATOR = 'generator',
  GOURMET_AREA = 'gourmet_area',
  GOURMET_TERRACE = 'gourmet_terrace',
  GREEN_SPACE = 'green_space',
  GYM = 'gym',
  HAS_LAVABO = 'has_lavabo',
  HEATED_POOL = 'heated_pool',
  HOME_OFFICE = 'home_office',
  KIDS_SPACE = 'kids_space',
  LAUNDRY = 'laundry',
  MEDIA_ROOM = 'media_room',
  NEAR_METRO = 'near_metro',
  NIGHTTIME_FRONTDESK = 'nighttime_frontdesk',
  ONE_PER_FLOOR = 'one_per_floor',
  PANTRY = 'pantry',
  PARKING_LOT = 'parking_lot',
  PETS = 'pets',
  PETS_ALLOWED = 'pets_allowed',
  PLAYGROUND = 'playground',
  POOL = 'pool',
  PRIVATE_HALL = 'private_hall',
  PRIVATE_POOL = 'private_pool',
  RENOVATED = 'renovated',
  SAUNA = 'sauna',
  SERVICE_AREA = 'service_area',
  SPA = 'spa',
  SPORTS_COURT = 'sports_court',
  TENNIS_COURT = 'tennis_court',
  TERRACE = 'terrace',
  VALET_PARKING = 'valet_parking',
  WAREHOUSE = 'warehouse',
  WITHOUT_FRONTDESK = 'without_frontdesk',
  YARD = 'yard',
}

export interface CondoFeatureObject extends CondoDictionaryObject<CondoFeatureEnum> {
	category: CondoFeatureCategory;
}

export const condoFeaturesArray: CondoFeatureObject[] = [
	{ name: 'Acessibilidade', identifier: CondoFeatureEnum.ACCESSIBILITY, category: CondoFeatureCategory.FACILITIES },
  { name: 'Ar-condicionado', identifier: CondoFeatureEnum.AIR_CONDITIONING, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Portaria 24hrs', identifier: CondoFeatureEnum.ALL_TIME_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  { name: 'Arquitetura de autor', identifier: CondoFeatureEnum.AUTHOR_ARCHITECTURE, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Salão de festas', identifier: CondoFeatureEnum.BANQUET_HALL, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Churrasqueira', identifier: CondoFeatureEnum.BARBECUE_GRILL, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Banheira', identifier: CondoFeatureEnum.BATHTUB, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Bicicletário', identifier: CondoFeatureEnum.BIKE_PARKING, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Closet', identifier: CondoFeatureEnum.CLOSET, category: CondoFeatureCategory.ROOMS },
  { name: 'Coworking', identifier: CondoFeatureEnum.COWORKING, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Portaria diurna', identifier: CondoFeatureEnum.DAYTIME_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  { name: 'Vaga escriturada', identifier: CondoFeatureEnum.DEED_PARKING_SPOT, category: CondoFeatureCategory.FACILITIES },
  { name: 'Elevador de delivery', identifier: CondoFeatureEnum.DELIVERY_ELEVATOR, category: CondoFeatureCategory.FACILITIES },
  { name: 'Vaga carro elétrico', identifier: CondoFeatureEnum.ELECTRIC_CAR_PARKING_SPOT, category: CondoFeatureCategory.FACILITIES },
  { name: 'Aquecimento elétrico', identifier: CondoFeatureEnum.ELECTRIC_HEATING, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Portaria eletrônica', identifier: CondoFeatureEnum.ELECTRONIC_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  { name: 'Lareira', identifier: CondoFeatureEnum.FIREPLACE, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Vaga demarcada', identifier: CondoFeatureEnum.FIXED_PARKING_SPOT, category: CondoFeatureCategory.FACILITIES },
  { name: 'Para reformar', identifier: CondoFeatureEnum.FOR_RENOVATION, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Vaga livre', identifier: CondoFeatureEnum.FREE_PARKING_SPOT, category: CondoFeatureCategory.FACILITIES },
  { name: 'Mobiliado', identifier: CondoFeatureEnum.FURNISHED, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Salão de jogos', identifier: CondoFeatureEnum.GAME_ROOM, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Aquecimento à gás', identifier: CondoFeatureEnum.GAS_HEATING, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Gerador', identifier: CondoFeatureEnum.GENERATOR, category: CondoFeatureCategory.FACILITIES },
  { name: 'Espaço gourmet', identifier: CondoFeatureEnum.GOURMET_AREA, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Varanda gourmet', identifier: CondoFeatureEnum.GOURMET_TERRACE, category: CondoFeatureCategory.ROOMS },
  { name: 'Área verde', identifier: CondoFeatureEnum.GREEN_SPACE, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Academia', identifier: CondoFeatureEnum.GYM, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Lavabo', identifier: CondoFeatureEnum.HAS_LAVABO, category: CondoFeatureCategory.ROOMS },
  { name: 'Piscina aquecida', identifier: CondoFeatureEnum.HEATED_POOL, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Home office', identifier: CondoFeatureEnum.HOME_OFFICE, category: CondoFeatureCategory.ROOMS },
  { name: 'Brinquedoteca', identifier: CondoFeatureEnum.KIDS_SPACE, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Lavanderia', identifier: CondoFeatureEnum.LAUNDRY, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Cinema', identifier: CondoFeatureEnum.MEDIA_ROOM, category: CondoFeatureCategory.ROOMS },
  { name: 'Próximo ao metrô', identifier: CondoFeatureEnum.NEAR_METRO, category: CondoFeatureCategory.FACILITIES },
  { name: 'Portaria noturna', identifier: CondoFeatureEnum.NIGHTTIME_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  { name: 'Um por andar', identifier: CondoFeatureEnum.ONE_PER_FLOOR, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Despensa', identifier: CondoFeatureEnum.PANTRY, category: CondoFeatureCategory.ROOMS },
  { name: 'Estacionamento', identifier: CondoFeatureEnum.PARKING_LOT, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Pet place', identifier: CondoFeatureEnum.PETS, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Permite animais', identifier: CondoFeatureEnum.PETS_ALLOWED, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Playground', identifier: CondoFeatureEnum.PLAYGROUND, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Piscina', identifier: CondoFeatureEnum.POOL, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Hall privativo', identifier: CondoFeatureEnum.PRIVATE_HALL, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Piscina privativa', identifier: CondoFeatureEnum.PRIVATE_POOL, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Reformado', identifier: CondoFeatureEnum.RENOVATED, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Sauna', identifier: CondoFeatureEnum.SAUNA, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Área de serviço', identifier: CondoFeatureEnum.SERVICE_AREA, category: CondoFeatureCategory.ROOMS },
  { name: 'Spa', identifier: CondoFeatureEnum.SPA, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Quadra esportiva', identifier: CondoFeatureEnum.SPORTS_COURT, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Quadra de tênis', identifier: CondoFeatureEnum.TENNIS_COURT, category: CondoFeatureCategory.EXTERNAL_AREA },
  { name: 'Varanda', identifier: CondoFeatureEnum.TERRACE, category: CondoFeatureCategory.ROOMS },
  { name: 'Manobrista', identifier: CondoFeatureEnum.VALET_PARKING, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Depósito privativo', identifier: CondoFeatureEnum.WAREHOUSE, category: CondoFeatureCategory.DIFFERENTIALS },
  { name: 'Sem portaria', identifier: CondoFeatureEnum.WITHOUT_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  { name: 'Quintal', identifier: CondoFeatureEnum.YARD, category: CondoFeatureCategory.EXTERNAL_AREA },
];

export const condoFeatures: Record<CondoFeatureEnum, CondoFeatureObject> = {
	[CondoFeatureEnum.ACCESSIBILITY]: { name: 'Acessibilidade', identifier: CondoFeatureEnum.ACCESSIBILITY, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.AIR_CONDITIONING]: { name: 'Ar-condicionado', identifier: CondoFeatureEnum.AIR_CONDITIONING, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.ALL_TIME_FRONTDESK]: { name: 'Portaria 24hrs', identifier: CondoFeatureEnum.ALL_TIME_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.AUTHOR_ARCHITECTURE]: { name: 'Arquitetura de autor', identifier: CondoFeatureEnum.AUTHOR_ARCHITECTURE, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.BANQUET_HALL]: { name: 'Salão de festas', identifier: CondoFeatureEnum.BANQUET_HALL, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.BARBECUE_GRILL]: { name: 'Churrasqueira', identifier: CondoFeatureEnum.BARBECUE_GRILL, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.BATHTUB]: { name: 'Banheira', identifier: CondoFeatureEnum.BATHTUB, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.BIKE_PARKING]: { name: 'Bicicletário', identifier: CondoFeatureEnum.BIKE_PARKING, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.CLOSET]: { name: 'Closet', identifier: CondoFeatureEnum.CLOSET, category: CondoFeatureCategory.ROOMS },
  [CondoFeatureEnum.COWORKING]: { name: 'Coworking', identifier: CondoFeatureEnum.COWORKING, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.DAYTIME_FRONTDESK]: { name: 'Portaria diurna', identifier: CondoFeatureEnum.DAYTIME_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.DEED_PARKING_SPOT]: { name: 'Vaga escriturada', identifier: CondoFeatureEnum.DEED_PARKING_SPOT, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.DELIVERY_ELEVATOR]: { name: 'Elevador de delivery', identifier: CondoFeatureEnum.DELIVERY_ELEVATOR, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.ELECTRIC_CAR_PARKING_SPOT]: { name: 'Vaga carro elétrico', identifier: CondoFeatureEnum.ELECTRIC_CAR_PARKING_SPOT, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.ELECTRIC_HEATING]: { name: 'Aquecimento elétrico', identifier: CondoFeatureEnum.ELECTRIC_HEATING, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.ELECTRONIC_FRONTDESK]: { name: 'Portaria eletrônica', identifier: CondoFeatureEnum.ELECTRONIC_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.FIREPLACE]: { name: 'Lareira', identifier: CondoFeatureEnum.FIREPLACE, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.FIXED_PARKING_SPOT]: { name: 'Vaga demarcada', identifier: CondoFeatureEnum.FIXED_PARKING_SPOT, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.FOR_RENOVATION]: { name: 'Para reformar', identifier: CondoFeatureEnum.FOR_RENOVATION, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.FREE_PARKING_SPOT]: { name: 'Vaga livre', identifier: CondoFeatureEnum.FREE_PARKING_SPOT, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.FURNISHED]: { name: 'Mobiliado', identifier: CondoFeatureEnum.FURNISHED, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.GAME_ROOM]: { name: 'Salão de jogos', identifier: CondoFeatureEnum.GAME_ROOM, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.GAS_HEATING]: { name: 'Aquecimento à gás', identifier: CondoFeatureEnum.GAS_HEATING, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.GENERATOR]: { name: 'Gerador', identifier: CondoFeatureEnum.GENERATOR, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.GOURMET_AREA]: { name: 'Espaço gourmet', identifier: CondoFeatureEnum.GOURMET_AREA, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.GOURMET_TERRACE]: { name: 'Varanda gourmet', identifier: CondoFeatureEnum.GOURMET_TERRACE, category: CondoFeatureCategory.ROOMS },
  [CondoFeatureEnum.GREEN_SPACE]: { name: 'Área verde', identifier: CondoFeatureEnum.GREEN_SPACE, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.GYM]: { name: 'Academia', identifier: CondoFeatureEnum.GYM, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.HAS_LAVABO]: { name: 'Lavabo', identifier: CondoFeatureEnum.HAS_LAVABO, category: CondoFeatureCategory.ROOMS },
  [CondoFeatureEnum.HEATED_POOL]: { name: 'Piscina aquecida', identifier: CondoFeatureEnum.HEATED_POOL, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.HOME_OFFICE]: { name: 'Home office', identifier: CondoFeatureEnum.HOME_OFFICE, category: CondoFeatureCategory.ROOMS },
  [CondoFeatureEnum.KIDS_SPACE]: { name: 'Brinquedoteca', identifier: CondoFeatureEnum.KIDS_SPACE, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.LAUNDRY]: { name: 'Lavanderia', identifier: CondoFeatureEnum.LAUNDRY, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.MEDIA_ROOM]: { name: 'Cinema', identifier: CondoFeatureEnum.MEDIA_ROOM, category: CondoFeatureCategory.ROOMS },
  [CondoFeatureEnum.NEAR_METRO]: { name: 'Próximo ao metrô', identifier: CondoFeatureEnum.NEAR_METRO, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.NIGHTTIME_FRONTDESK]: { name: 'Portaria noturna', identifier: CondoFeatureEnum.NIGHTTIME_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.ONE_PER_FLOOR]: { name: 'Um por andar', identifier: CondoFeatureEnum.ONE_PER_FLOOR, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.PANTRY]: { name: 'Despensa', identifier: CondoFeatureEnum.PANTRY, category: CondoFeatureCategory.ROOMS },
  [CondoFeatureEnum.PARKING_LOT]: { name: 'Estacionamento', identifier: CondoFeatureEnum.PARKING_LOT, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.PETS]: { name: 'Pet place', identifier: CondoFeatureEnum.PETS, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.PETS_ALLOWED]: { name: 'Permite animais', identifier: CondoFeatureEnum.PETS_ALLOWED, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.PLAYGROUND]: { name: 'Playground', identifier: CondoFeatureEnum.PLAYGROUND, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.POOL]: { name: 'Piscina', identifier: CondoFeatureEnum.POOL, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.PRIVATE_HALL]: { name: 'Hall privativo', identifier: CondoFeatureEnum.PRIVATE_HALL, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.PRIVATE_POOL]: { name: 'Piscina privativa', identifier: CondoFeatureEnum.PRIVATE_POOL, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.RENOVATED]: { name: 'Reformado', identifier: CondoFeatureEnum.RENOVATED, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.SAUNA]: { name: 'Sauna', identifier: CondoFeatureEnum.SAUNA, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.SERVICE_AREA]: { name: 'Área de serviço', identifier: CondoFeatureEnum.SERVICE_AREA, category: CondoFeatureCategory.ROOMS },
  [CondoFeatureEnum.SPA]: { name: 'Spa', identifier: CondoFeatureEnum.SPA, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.SPORTS_COURT]: { name: 'Quadra esportiva', identifier: CondoFeatureEnum.SPORTS_COURT, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.TENNIS_COURT]: { name: 'Quadra de tênis', identifier: CondoFeatureEnum.TENNIS_COURT, category: CondoFeatureCategory.EXTERNAL_AREA },
  [CondoFeatureEnum.TERRACE]: { name: 'Varanda', identifier: CondoFeatureEnum.TERRACE, category: CondoFeatureCategory.ROOMS },
  [CondoFeatureEnum.VALET_PARKING]: { name: 'Manobrista', identifier: CondoFeatureEnum.VALET_PARKING, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.WAREHOUSE]: { name: 'Depósito privativo', identifier: CondoFeatureEnum.WAREHOUSE, category: CondoFeatureCategory.DIFFERENTIALS },
  [CondoFeatureEnum.WITHOUT_FRONTDESK]: { name: 'Sem portaria', identifier: CondoFeatureEnum.WITHOUT_FRONTDESK, category: CondoFeatureCategory.FACILITIES },
  [CondoFeatureEnum.YARD]: { name: 'Quintal', identifier: CondoFeatureEnum.YARD, category: CondoFeatureCategory.EXTERNAL_AREA },
};

export const condoFeaturesTranslations: Record<CondoFeatureEnum, string> = {
	[CondoFeatureEnum.ACCESSIBILITY]: 'Acessibilidade',
  [CondoFeatureEnum.AIR_CONDITIONING]: 'Ar-condicionado',
  [CondoFeatureEnum.ALL_TIME_FRONTDESK]: 'Portaria 24hrs',
  [CondoFeatureEnum.AUTHOR_ARCHITECTURE]: 'Arquitetura de autor',
  [CondoFeatureEnum.BANQUET_HALL]: 'Salão de festas',
  [CondoFeatureEnum.BARBECUE_GRILL]: 'Churrasqueira',
  [CondoFeatureEnum.BATHTUB]: 'Banheira',
  [CondoFeatureEnum.BIKE_PARKING]: 'Bicicletário',
  [CondoFeatureEnum.CLOSET]: 'Closet',
  [CondoFeatureEnum.COWORKING]: 'Coworking',
  [CondoFeatureEnum.DAYTIME_FRONTDESK]: 'Portaria diurna',
  [CondoFeatureEnum.DEED_PARKING_SPOT]: 'Vaga escriturada',
  [CondoFeatureEnum.DELIVERY_ELEVATOR]: 'Elevador de delivery',
  [CondoFeatureEnum.ELECTRIC_CAR_PARKING_SPOT]: 'Vaga carro elétrico',
  [CondoFeatureEnum.ELECTRIC_HEATING]: 'Aquecimento elétrico',
  [CondoFeatureEnum.ELECTRONIC_FRONTDESK]: 'Portaria eletrônica',
  [CondoFeatureEnum.FIREPLACE]: 'Lareira',
  [CondoFeatureEnum.FIXED_PARKING_SPOT]: 'Vaga demarcada',
  [CondoFeatureEnum.FOR_RENOVATION]: 'Para reformar',
  [CondoFeatureEnum.FREE_PARKING_SPOT]: 'Vaga livre',
  [CondoFeatureEnum.FURNISHED]: 'Mobiliado',
  [CondoFeatureEnum.GAME_ROOM]: 'Salão de jogos',
  [CondoFeatureEnum.GAS_HEATING]: 'Aquecimento à gás',
  [CondoFeatureEnum.GENERATOR]: 'Gerador',
  [CondoFeatureEnum.GOURMET_AREA]: 'Espaço gourmet',
  [CondoFeatureEnum.GOURMET_TERRACE]: 'Varanda gourmet',
  [CondoFeatureEnum.GREEN_SPACE]: 'Área verde',
  [CondoFeatureEnum.GYM]: 'Academia',
  [CondoFeatureEnum.HAS_LAVABO]: 'Lavabo',
  [CondoFeatureEnum.HEATED_POOL]: 'Piscina aquecida',
  [CondoFeatureEnum.HOME_OFFICE]: 'Home office',
  [CondoFeatureEnum.KIDS_SPACE]: 'Brinquedoteca',
  [CondoFeatureEnum.LAUNDRY]: 'Lavanderia',
  [CondoFeatureEnum.MEDIA_ROOM]: 'Cinema',
  [CondoFeatureEnum.NEAR_METRO]: 'Próximo ao metrô',
  [CondoFeatureEnum.NIGHTTIME_FRONTDESK]: 'Portaria noturna',
  [CondoFeatureEnum.ONE_PER_FLOOR]: 'Um por andar',
  [CondoFeatureEnum.PANTRY]: 'Despensa',
  [CondoFeatureEnum.PARKING_LOT]: 'Estacionamento',
  [CondoFeatureEnum.PETS]: 'Pet place',
  [CondoFeatureEnum.PETS_ALLOWED]: 'Permite animais',
  [CondoFeatureEnum.PLAYGROUND]: 'Playground',
  [CondoFeatureEnum.POOL]: 'Piscina',
  [CondoFeatureEnum.PRIVATE_HALL]: 'Hall privativo',
  [CondoFeatureEnum.PRIVATE_POOL]: 'Piscina privativa',
  [CondoFeatureEnum.RENOVATED]: 'Reformado',
  [CondoFeatureEnum.SAUNA]: 'Sauna',
  [CondoFeatureEnum.SERVICE_AREA]: 'Área de serviço',
  [CondoFeatureEnum.SPA]: 'Spa',
  [CondoFeatureEnum.SPORTS_COURT]: 'Quadra esportiva',
  [CondoFeatureEnum.TENNIS_COURT]: 'Quadra de tênis',
  [CondoFeatureEnum.TERRACE]: 'Varanda',
  [CondoFeatureEnum.VALET_PARKING]: 'Manobrista',
  [CondoFeatureEnum.WAREHOUSE]: 'Depósito privativo',
  [CondoFeatureEnum.WITHOUT_FRONTDESK]: 'Sem portaria',
  [CondoFeatureEnum.YARD]: 'Quintal',
}

export const condoFeaturesByCategory: Record<CondoFeatureCategory, CondoFeatureEnum[]> = {
	[CondoFeatureCategory.FACILITIES]: [CondoFeatureEnum.ACCESSIBILITY, CondoFeatureEnum.ALL_TIME_FRONTDESK, CondoFeatureEnum.DAYTIME_FRONTDESK, CondoFeatureEnum.DEED_PARKING_SPOT, CondoFeatureEnum.DELIVERY_ELEVATOR, CondoFeatureEnum.ELECTRIC_CAR_PARKING_SPOT, CondoFeatureEnum.ELECTRONIC_FRONTDESK, CondoFeatureEnum.FIXED_PARKING_SPOT, CondoFeatureEnum.FREE_PARKING_SPOT, CondoFeatureEnum.GENERATOR, CondoFeatureEnum.NEAR_METRO, CondoFeatureEnum.NIGHTTIME_FRONTDESK, CondoFeatureEnum.WITHOUT_FRONTDESK],
  [CondoFeatureCategory.DIFFERENTIALS]: [CondoFeatureEnum.AIR_CONDITIONING, CondoFeatureEnum.AUTHOR_ARCHITECTURE, CondoFeatureEnum.BATHTUB, CondoFeatureEnum.ELECTRIC_HEATING, CondoFeatureEnum.FIREPLACE, CondoFeatureEnum.FOR_RENOVATION, CondoFeatureEnum.FURNISHED, CondoFeatureEnum.GAS_HEATING, CondoFeatureEnum.ONE_PER_FLOOR, CondoFeatureEnum.PETS, CondoFeatureEnum.PETS_ALLOWED, CondoFeatureEnum.PRIVATE_HALL, CondoFeatureEnum.PRIVATE_POOL, CondoFeatureEnum.RENOVATED, CondoFeatureEnum.VALET_PARKING, CondoFeatureEnum.WAREHOUSE],
  [CondoFeatureCategory.EXTERNAL_AREA]: [CondoFeatureEnum.BANQUET_HALL, CondoFeatureEnum.BARBECUE_GRILL, CondoFeatureEnum.BIKE_PARKING, CondoFeatureEnum.COWORKING, CondoFeatureEnum.GAME_ROOM, CondoFeatureEnum.GOURMET_AREA, CondoFeatureEnum.GREEN_SPACE, CondoFeatureEnum.GYM, CondoFeatureEnum.HEATED_POOL, CondoFeatureEnum.KIDS_SPACE, CondoFeatureEnum.LAUNDRY, CondoFeatureEnum.PARKING_LOT, CondoFeatureEnum.PLAYGROUND, CondoFeatureEnum.POOL, CondoFeatureEnum.SAUNA, CondoFeatureEnum.SPA, CondoFeatureEnum.SPORTS_COURT, CondoFeatureEnum.TENNIS_COURT, CondoFeatureEnum.YARD],
  [CondoFeatureCategory.ROOMS]: [CondoFeatureEnum.CLOSET, CondoFeatureEnum.GOURMET_TERRACE, CondoFeatureEnum.HAS_LAVABO, CondoFeatureEnum.HOME_OFFICE, CondoFeatureEnum.MEDIA_ROOM, CondoFeatureEnum.PANTRY, CondoFeatureEnum.SERVICE_AREA, CondoFeatureEnum.TERRACE],
};
	